import React, { ReactNode, Ref, forwardRef, useImperativeHandle, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'

export type ModalWrapperProps = {
  onSomething?: () => void
  confirmButtonName?: string
  declineButtonName?: string
  onProcessed?: () => void
  title?: string
  children: ReactNode | ReactNode[]
  size?: 'sm' | 'lg' | 'xl'
}

export type ModalWrapperRefObject = {
  showModal: () => void
}

export const ModalWrapper = forwardRef((props: ModalWrapperProps, ref: Ref<ModalWrapperRefObject>): React.ReactElement => {
  const { confirmButtonName, declineButtonName, onProcessed, title, children, size = 'lg' } = props
  const [isVisible, setIsVisible] = useState(false)

  useImperativeHandle(ref, () => ({
    showModal: handleShowModal,
  }))

  const handleShowModal = (): void => {
    setIsVisible(true)
  }

  const delayedAnswer = (): void => {
    if (onProcessed) setTimeout(() => onProcessed!(), 300)
  }

  const handleConfirm = (): void => {
    delayedAnswer()
    setIsVisible(false)
  }
  const handleDecline = (): void => {
    setIsVisible(false)
  }
  const handleCancel = (): void => {
    setIsVisible(false)
  }

  return (
    <Modal show={isVisible} onHide={handleCancel} size={size}>
      {title && (
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      )}

      <Modal.Body>{children}</Modal.Body>
      {(declineButtonName || confirmButtonName) && (
        <Modal.Footer>
          {declineButtonName && (
            <Button type="button" onClick={handleDecline} variant="secondary">
              {declineButtonName}
            </Button>
          )}
          {confirmButtonName && (
            <Button type="button" onClick={handleConfirm} variant="primary">
              {confirmButtonName}
            </Button>
          )}
        </Modal.Footer>
      )}
    </Modal>
  )
})
